<style lang="less" scoped>
.book-textreadguide {
  // background-color: #f1f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}
.book-textreadguide-content {
  border-radius: @border-radius-base;
  background-color: @white;
  width: 100%;
  // margin-top: 30px;
  // padding-top: 53px;
  padding-left: 30px;
  padding-bottom: 55px;
  padding-right: 30px;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 185px);
 // max-height: 600px;
  overflow-y: auto;

  .back-Btn {
    display: inline-block;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #dbd1cd;
    height: 30px;
    .back-Icon {
      height: 19px;
      position: relative;
      right: 10px;
    }
  }
  .back-Btn:hover {
    color: @primary-color;
  }
  .textreadguide-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
  .textreadguide-content {
    background-color: #f6f6f6;
    font-size: 16px;
    padding: 10px 15px;
    white-space: pre-wrap;
    line-height: 2em;
    border-radius: 5px;
  }
}
</style>

<template>
  <div class="book-textreadguide">
    <a-spin class="loading" v-show="loading" />
    <div class="book-textreadguide-content">
      <!-- <div class="back-Btn" @click="goArticle">
        <han-icon type="leftDobuleArrowIcon" class="back-Icon" />
        <span>返回课文</span>
      </div> -->
      <div class="textreadguide-title">课文导读</div>
      <a-carousel v-if="readGuide.imageList" autoplay>
        <div v-for="img in readGuide.imageList" :key="img.id" style="text-align: center">
          <img style="max-height:300px;max-width:100%;margin:auto" :src="$resBasePath+img.path">
        </div>
      </a-carousel>
      <div v-if="readGuide" class="textreadguide-content" v-html="readGuide.commentContent"></div>
      <div v-else>
        <a-empty />
      </div>
    </div>
  </div>
</template>

<script>
import HanIcon from 'components/Icon.vue';
export default {
  name: 'TextReadGuide',
  components: { HanIcon },
  data() {
    return {
      loading: false,
      readGuide: {},
      styleId: localStorage.getItem('styleId'),
    };
  },
  watch: {
    $route() {
      this.getTextReadGuide();
    },
  },
  methods: {
    goArticle() {
      this.$router.push({ path: `/books/reading-book/${this.$route.params.id}` });
    },
    getTextReadGuide() {
      this.$fetch({
        url: this.$httpConfig.getTeacherTextGuide,
        body: {
          styleId: this.styleId,
          rangeType: 4,
        },
      })
        .loading(() => (this.loading = true))
        .done((res) => {
          this.readGuide = res.resultData;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getTextReadGuide();
  },
};
</script>
